module.exports = __webpack_public_path__ + "img/mobile-legends.9a6e504.png";